<template>
  <VPopover
    :offset="6"
    popover-wrapper-class="popover-wrapper"
  >
    <div style="padding: 0.375rem 0.75rem;">
      <FormatColumnsIcon title="" />
      Columns
    </div>
    <template #popover>
      <div>
        <div class="pb-1 px-1">
          <a
            href="#"
            @click.prevent="selectAll()"
          >Select all</a>
          <a
            href="#"
            class="float-right"
            @click.prevent="reset()"
          >Reset</a>
        </div>
        <div
          class="filter-options overflow-auto p-1"
          style="max-height: 270px;"
        >
          <div
            v-for="(f, i) in innerValue"
            :key="f.name"
            class="d-flex filter-option"
          >
            <div class="custom-control custom-checkbox d-inline-block">
              <input
                :id="`column-filter-${f.name}`"
                :checked="f.visible"
                type="checkbox"
                class="custom-control-input"
                :disabled="f.visible && selectedCount === 1"
                @input="setField(i, !f.visible)"
              >
              <label
                class="custom-control-label user-select-none font-weight-normal text-nowrap"
                :for="`column-filter-${f.name}`"
              />
            </div>
            <div class="w-100 d-inline-block">
              {{ f.title || f.name }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </VPopover>
</template>

<script>
import { VPopover } from 'v-tooltip'
import FormatColumnsIcon from 'vue-material-design-icons/FormatColumns.vue'

export default {
  components: {
    VPopover,
    FormatColumnsIcon,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },

  },
  computed: {
    innerValue: {
      get () { return this.value },
      set (n) { this.$emit('input', n) },
    },
    // localStorage field name for visible fields
    localFieldName () {
      return `${this.$route.name}:visibleFields`
    },
    fieldsByName () {
      return this.getFieldsByName(this.fields)
    },
    defaultFields () {
      // fix visible field in fields
      return this.fields.map(f => {
        return { ...f, visible: !!f.visible || f.visible === undefined }
      })
    },
    selectedCount () {
      return this.value.filter(f => f.visible).length
    },
  },
  watch: {
    localFieldName: {
      handler: function () {
        this.$emit('input', this.getUserFields())
      },
      immediate: true,
    },
  },
  methods: {
    saveUserFields (fields) {
      // only save name and visible flag
      const data = fields.map(f => { return { name: f.name, visible: f.visible } })
      localStorage.setItem(this.localFieldName, JSON.stringify(data))
      this.$emit('input', fields)
    },
    reset () {
      const fields = this.fields.map(f => { return { ...f } })
      this.saveUserFields(fields)
    },
    selectAll () {
      const fields = this.innerValue.map(f => { return { ...f, visible: true } })
      this.saveUserFields(fields)
    },
    setField (index, checked) {
      const fields = this.innerValue.map(f => { return { ...f } })
      fields[index].visible = checked
      this.saveUserFields(fields)
    },
    getFieldsByName (fields) {
      return fields.reduce((acc, curr) => {
        acc[curr.name] = curr
        return acc
      }, {})
    },
    getFieldsFromStorage () {
      var fields = localStorage.getItem(this.localFieldName)
      try {
        fields = JSON.parse(fields)
      } catch (e) {
        return []
      }
      return Array.isArray(fields) ? fields : []
    },
    getUserFields () {
      // get valid fields from storage
      var userFields = this.getFieldsFromStorage().filter(f => this.fieldsByName[f.name])
      // return default fields if empty
      if (userFields.length === 0) {
        return this.fields.map(f => {
          return { ...f, visible: !!f.visible || f.visible === undefined }
        })
      }
      // get full object for each user field
      userFields = userFields.map(f => {
        return { ...this.fieldsByName[f.name], visible: !!f.visible }
      })
      // get fields missing from storage and mark as not visible
      const userFieldsByName = this.getFieldsByName(userFields)
      const missingFields = this.fields
        .filter(f => !userFieldsByName[f.name])
        .map(f => { return { ...f, visible: false } })
      // combine stored and missing fields
      return userFields.concat(missingFields)
    },
  },
}
</script>

<style lang="scss" scoped>
// hack to  hide label
.custom-control {
   padding-left: 0px;
   .custom-control-label {
     width: 24px;
     &::before,
     &::after {
       left: 0;
     }
   }
}
</style>
